import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import ReactRouterPropTypes from 'react-router-prop-types';
import { connect } from 'react-redux';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import {
  changeLoadingFalse,
  changeLoadingTrue,
} from '../../redux/actions/loadingActions';
import Modal from '../../shared/components/Modal';
import columns from './components/Columns';
import { DEFAULT_PAGE_SIZE } from '../../shared/utils/constants';
import AcademicCalendarFilter from './components/AcademicCalendarFilter';
import MaterialTable from '../../shared/components/material-table';
import { schoolTermListIdAndName } from '../../shared/queries/SchoolTerm';
import GraphQL from '../../GraphQL';
import {
  academicCalendarListByFilterTable,
  academicCalendarRemove,
} from '../../shared/queries/AcademicCalendar';
import { showNotificationAutoDestroy } from '../../shared/components/ShowNotification';

const AcademicCalendar = (props) => {
  const { t, dispatch, history } = props;
  const [data, setData] = useState([]);
  const [modal, setModal] = useState(false);
  const [selectedDto, setSelectedDto] = useState();
  const [filterIsOpen, setFilterIsOpen] = useState();
  const [lastFilter, setLastFilter] = useState(null);
  const [schoolTerms, setSchoolTerms] = useState([]);

  const showLoading = () => {
    dispatch(changeLoadingTrue());
  };

  const hideLoading = () => {
    dispatch(changeLoadingFalse());
  };

  const onFilterToggle = () => {
    setFilterIsOpen(!filterIsOpen);
  };

  const loadSchoolTerms = () => {
    const query = schoolTermListIdAndName();
    GraphQL(query, {}).then((res) => {
      res.schoolTermListAll = res.schoolTermListAll.map((item) => ({
        ...item,
        label: item.name,
        value: item.id,
      }));
      setSchoolTerms(res.schoolTermListAll);
    });
  };

  const loadCalendars = (filter) => {
    if (filterIsOpen) {
      onFilterToggle();
    }
    showLoading();
    const query = academicCalendarListByFilterTable(filter);
    GraphQL(query, {})
      .then((res) => {
        if (res.academicCalendarListByFilter) {
          setData(res.academicCalendarListByFilter);
        }
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-remove')
        );
      })
      .finally(() => {
        hideLoading();
      });
  };

  const toggleModal = () => {
    setModal(!modal);
  };

  const addItemClickHandler = () => {
    setSelectedDto({ active: true, id: 0 });
    history.push(`/minime/calendario-academico/mnt/0`);
  };

  const removeItemClickHandler = (evt, rowData) => {
    setSelectedDto({
      ...rowData,
    });
    toggleModal();
  };

  const editItemClickHandler = (evt, rowData) => {
    setSelectedDto({
      rowData,
    });
    history.push(`/minime/calendario-academico/mnt/${rowData.id}`);
  };

  const onFilterClickHandler = (filter) => {
    if (filter) {
      setLastFilter(filter);
      loadCalendars(filter);
    } else if (lastFilter) {
      loadCalendars(lastFilter);
    } else {
      loadCalendars({});
    }
  };

  const filterBuildFunction = () => (
    <AcademicCalendarFilter
      isFiltering={filterIsOpen}
      filterClick={onFilterClickHandler}
      lastFilter={lastFilter}
      schoolTerms={schoolTerms}
    />
  );

  const deleteItem = () => {
    toggleModal();
    showLoading();
    const removeMutation = academicCalendarRemove(selectedDto.id);
    GraphQL(removeMutation, {})
      .then(() => {
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-removed')
        );
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        hideLoading();
        onFilterClickHandler();
      });
  };

  useEffect(() => {
    loadSchoolTerms();
    onFilterClickHandler();
  }, []);

  return (
    <Fragment>
      <Modal
        color="warning"
        title={t('notifications.attention')}
        btn="Warning"
        message={t('notifications.delete_modal')}
        toggle={toggleModal}
        modal={modal}
        onConfirm={deleteItem}
      />
      <Container>
        <Row className="Table">
          <Col md={12} lg={12}>
            <Card>
              <CardBody className="material-table-card">
                <div className="material-table__wrap">
                  <MaterialTable
                    showFilter
                    title={t('panels.academic-calendar')}
                    data={data}
                    columns={columns(t)}
                    isFiltering={filterIsOpen}
                    filterToggle={onFilterToggle}
                    filterBuildFunction={filterBuildFunction}
                    pageSize={DEFAULT_PAGE_SIZE}
                    deleteAction={toggleModal}
                    onRefreshClick={onFilterClickHandler}
                    onAddClick={addItemClickHandler}
                    onRemoveClick={removeItemClickHandler}
                    onEditClick={editItemClickHandler}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

AcademicCalendar.propTypes = {
  t: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(AcademicCalendar)
);
